import flyers from './flyers.initialState'
import flyerGibs from './flyerGibs.initialState'
import products from './products.initialState'
import tags from './tags.initialState'
import brands from './brands.initialState'
import stores from './stores.initialState'
import user from './user.initialState'
import ui from './ui.initialState'
import tracking from './tracking.initialState'
import viewer from './viewer.initialState'
import property from './property.initialState'
import application from './application.initialState'
import routerMatch from './routerMatch.initialState'
import dialog from './dialog.initialState'

export {
  flyers,
  flyerGibs,
  products,
  tags,
  brands,
  stores,
  user,
  ui,
  tracking,
  viewer,
  property,
  application,
  routerMatch,
  dialog,
}

export default {
  flyers,
  flyerGibs,
  products,
  tags,
  brands,
  stores,
  user,
  ui,
  tracking,
  viewer,
  property,
  application,
  routerMatch,
  dialog,
}
